<template>
    <div>
        <vue-multiselect v-if="options !== null"
                         v-model="selected"
                        :options="options"
                        track-by="id"
                        label="name"
                         :multiple="multiple"
                         :placeholder="placeholder"
                         v-bind="extraOptions"
                         :taggable="true"
                         @tag="addTag">
        </vue-multiselect>
    </div>
</template>
<script>
    import VueMultiselect from "vue-multiselect/src/Multiselect";
    export default {
        name: 'MultiSelectSearch',
        components: {
            VueMultiselect,
        },
        props: {
            exclude: {},
            value: {},
            multiple: {
                type: Boolean,
                default: true
            },
            placeholder: {
                type: String,
                default: 'Select option'
            },
            options: null
        },
        data () {
            return {
                extraOptions: {
                  'group-label': 'groupName',
                  'group-values': 'groupValues'
                }
            }
        },
        computed: {
            selected: {
                // getter
                get: function () {
                    return this.value;
                },
                // setter
                set: function (newValue) {
                  this.$emit('input', newValue);
                }
            },
        },
        mounted () {
        },
        methods: {
          addTag (newTag) {
            const tag = {
              name: newTag,
              id: newTag.toLowerCase(),
              type: 'fuzzy'
            }
            this.options.push(tag)
            this.value.push(tag)
            this.$emit('input', this.value);
          }
        }
    }

</script>
<style src="./MultiSelectSearch.scss" scoped lang="scss"></style>

